import axios from "axios";
import { endpoints } from "config/api";
import { getAuthToken } from "utils/helper";

export const getAllInventory = async (params) => {
  let request = await axios({
    method: "GET",
    url: endpoints.product.GET_ALL_INVENTORY,
    headers: {
      Authorization: getAuthToken(),
    },
    params: params,
  });
  return request;
};

export const getInventoryById = async (id) => {
  let request = await axios({
    method: "GET",
    url: `${endpoints.product.GET_INVENTORY_BY_ID}/${id}`,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};

export const updateInventory = async (data) => {
  let request = await axios({
    method: "PUT",
    url: endpoints.product.UPDATE_INVENTORY,
    headers: {
      Authorization: getAuthToken(),
    },
    data: data,
  });
  return request;
};

export const deleteInventory = async (id) => {
  let request = await axios({
    method: "DELETE",
    url: `${endpoints.product.DELETE_INVENTORY}/${id}`,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};


export const updateImage = async (data) => {
  let request = await axios({
    method: "PUT",
    url: endpoints.product.UPDATE_IMAGE,
    headers: {
      Authorization: getAuthToken(),
    },
    data: data,
  });
  return request;
};